import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { BaseError } from "../../components/pages/base-error";

@Injectable()
export class DomainControllerService extends BaseError {

  private baseUrl: string = environment.BASE_URL + "domain";

  constructor(private http: HttpClient, public toastr: ToastrService) {
    super(toastr);
  }

  public getDomainList(): Observable<string[]> {
    return this.http.get(this.baseUrl) as Observable<string[]>;
  }
}
